module.exports = __webpack_public_path__ + "img/renegociacao.055a9197.png";